/**
 * Chip 风格筛选组（单选）。多选可后续扩展。
 */

export interface ChipOption {
  value: string;
  label: string;
  count?: number;
}

interface ChipFilterProps {
  options: ChipOption[];
  value: string;
  onChange: (next: string) => void;
  label?: string;
  className?: string;
}

export default function ChipFilter({ options, value, onChange, label, className = '' }: ChipFilterProps) {
  return (
    <div className={`flex items-center gap-2 flex-wrap ${className}`}>
      {label && <span className="text-[12px] text-slate-500">{label}</span>}
      {options.map((o) => {
        const active = o.value === value;
        return (
          <button
            key={o.value}
            type="button"
            onClick={() => onChange(o.value)}
            className={`text-[12px] px-3 py-1 rounded-full border transition ${
              active
                ? 'bg-slate-900 text-white border-slate-900'
                : 'bg-white text-slate-600 border-slate-200 hover:border-slate-400'
            }`}
          >
            <span>{o.label}</span>
            {o.count !== undefined && (
              <span className={`ml-1 text-[10px] ${active ? 'opacity-70' : 'opacity-50'}`}>
                ·{o.count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
